import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EConsActionTypes {
  Set = 'NEW_REVIEW/CONS/SET',
}

export type TSetConsRating = ITypedReduxAction<EConsActionTypes.Set, string>;

/**
 * Redux action, который записывает в store минусы ЖК нового отзыва
 * @param cons string
 */
export const setConsRating: (cons: string) => TSetConsRating = actionGenerator<EConsActionTypes.Set, string>(
  EConsActionTypes.Set,
);
